/**
 * Alpine component: landingQuickAdd
 *
 * "Quick Add +" for snippets/card-landing-tw. Registered once per page (not
 * per card). Single-variant products add straight to the cart; products
 * with options open a small size popover where each option adds on click.
 *
 * After a successful add it fires the same window events as the rest of
 * the theme (cart:refresh, cart:open), so the Alpine cart drawer updates.
 */
document.addEventListener('alpine:init', () => {
  window.Alpine.data('landingQuickAdd', () => ({
    open: false,
    loadingId: null,
    error: '',

    toggle() {
      this.open ? this.close() : this.show();
    },

    show() {
      this.error = '';
      this.open = true;
      this.$nextTick(() => {
        const first = this.$refs.panel?.querySelector('button:not([disabled])');
        if (first) first.focus();
      });
    },

    close(returnFocus = true) {
      if (!this.open) return;
      this.open = false;
      if (returnFocus) this.$refs.trigger?.focus();
    },

    async add(variantId) {
      if (!variantId || this.loadingId) return;
      this.loadingId = variantId;
      this.error = '';

      try {
        const body = new FormData();
        body.append('id', variantId);
        body.append('quantity', 1);

        const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body,
        });

        if (!res.ok) {
          const data = await res.json().catch(() => ({}));
          throw new Error(data.description || data.message || 'Could not add to cart.');
        }

        this.close(false);
        window.dispatchEvent(new CustomEvent('cart:refresh'));
        window.dispatchEvent(new CustomEvent('cart:open'));
      } catch (err) {
        // Shown in the card's live region so the shopper knows what happened.
        this.error = err.message;
      } finally {
        this.loadingId = null;
      }
    },
  }));
});
